import { SUCCESS, CLEAR_SUCCESS } from './types';

/** actions for toggling api success states */
export function success() {
	return { type: SUCCESS };
}
export function clearSuccess() {
	return { type: CLEAR_SUCCESS };
}
